import React, { useState, useEffect } from 'react';

// Chakra imports
import {
  Box,
  Flex,
  Grid,
  Text,
  useColorModeValue,
  SimpleGrid,
  Button,
  Tooltip,
  Center,
  Spinner,
} from '@chakra-ui/react';

// Custom components
import { AddIcon } from '@chakra-ui/icons';

// Assets
import SavingsPlanApi from 'api/savingplan';
import SavingsPlanCard from './SavingsPlanCard';
import AddModal from './addSavingPlan';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { Modules } from 'config/constant';
import PageError from 'components/nopermission/PageError';

export default function AllSavingPlans() {
  // const btnVariant = useColorModeValue('dark', 'lightBrand');
  const [SavingplanList, setSavingplanList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listTotal, setListTotal] = useState(0);
  const { getPermissionsForModule } = usePermissions();
  const [savingPlanPermissions, setsavingPlanPermissions] = useState(null);
  const [fetchSavingsPlanListError, setFetchSavingsPlanListError] =
    useState(false);

  const FetchSavingsplanList = async () => {
    try {
      setLoading(true);
      let response = await SavingsPlanApi.List({
        //  currentPage,
        //  itemsPerPage,
        sort: 'name:asc',
        // searchTerm,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchSavingsPlanListError(false);
        console.log(response.data);
        setSavingplanList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchSavingsPlanListError(true);
        setSavingplanList(null);
        setListTotal(0);
      }
    } catch (err) {
      setFetchSavingsPlanListError(true);
      console.log(err);
    }
  };
  useEffect(() => {
    const savingPlanPermissions = getPermissionsForModule([Modules.SavingPlan]);
    setsavingPlanPermissions(savingPlanPermissions);
  }, [getPermissionsForModule]);

  useEffect(() => {
    if (savingPlanPermissions?.read) {
      FetchSavingsplanList();
    }
  }, [savingPlanPermissions]);

  console.log('enum', Modules.SavingPlan, savingPlanPermissions);
  // Chakra Color Mode
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  if (!savingPlanPermissions?.read) {
    return <NoPermissionsMessage module={Modules.SavingPlan} />;
  }

  return loading ? (
    <Center
      mt='10rem'
      width='100%'
      // bgColor='red'
    >
      <Spinner size='xl' />
    </Center>
  ) : fetchSavingsPlanListError ? (
    <PageError />
  ) : (
    <Box pt={{ base: '110px', md: '80px', xl: '80px' }}>
      {/* Main Fields */}
      <Grid
        mb='20px'
        // gridTemplateColumns={{ xl: 'repeat(2, 1fr)', '2xl': '1fr 0.46fr' }}
        gap={{ base: '20px', xl: '20px' }}
        display={{ base: 'block', xl: 'grid' }}>
        <Flex
          flexDirection='column'
          gridArea={{ xl: '1 / 1 / 2 / 3', '2xl': '1 / 1 / 2 / 2' }}>
          <Flex direction='column'>
            <Flex
              mt='45px'
              mb='40px'
              justifyContent='space-between'
              direction='row'
              align='center'>
              <Text
                color={textColor}
                fontSize='2xl'
                ms='24px'
                fontWeight='700'>
                All Plans
              </Text>
              <Tooltip
                label={
                  !savingPlanPermissions.create
                    ? 'You do not have permission to add'
                    : undefined
                }
                placement='top'
                shouldWrapChildren>
                <Button p='0'>
                  <AddModal
                    Icon={<AddIcon />}
                    head={'Add New Saving Plan'}
                    func={FetchSavingsplanList}
                    disabled={!savingPlanPermissions.create}
                  />
                </Button>
              </Tooltip>
            </Flex>
            <SimpleGrid
              columns={{ base: 1, md: 2, xl: 3, '3xl': 4 }}
              gap='20px'>
              {SavingplanList?.map((plan) => (
                <SavingsPlanCard
                  key={plan.id}
                  data={plan}
                  cardType='savingPlan'
                  permissions={savingPlanPermissions}
                />
              ))}
            </SimpleGrid>
          </Flex>
        </Flex>
      </Grid>
      {/* Delete Product */}
    </Box>
  );
}
